<div class="header">
    <img src="../../../assets/img/new-logo.svg" alt="Huiospay Logo" routerLink="/" style="cursor:pointer">

    <button class="hamburger" (click)="toggleMenu()" [class.open]="menuOpen" aria-label="Toggle menu">
        <span></span>
        <span></span>
        <span></span>
    </button>

    <div class="nav-links" [class.open]="menuOpen">
        <div routerLink="/why-huiospay" routerLinkActive="active">Why Huiospay</div>
        <div routerLink="/developers" routerLinkActive="active">Developer
        </div>

        <div class="dropdown" routerLinkActive="active">
            Company
            <app-font-icon iconType="remix" iconName="arrow-down-s-line" iconSize="custom" iconColor="#000000">
            </app-font-icon>
            <div class="dropdown-menu">
                <a routerLink="/about-us" routerLinkActive="active">About Us</a>
                <a routerLink="/careers" routerLinkActive="active">Careers</a>
            </div>
        </div>

        <div routerLink="/support" routerLinkActive="active">Support
            
        </div>

        <a href="https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16" target="_blank">
            <button class="mobile-cta">Create Merchant Account</button>
        </a>
    </div>

    <a class="desktop-cta-wrapper" href="https://dashboard.huiospay.com/registration/67a09908-6119-11ee-bfbe-7a0e4acd3f16" target="_blank">
        <button class="desktop-cta">Create Merchant Account</button>
    </a>
</div>
